export type FetchComponentDefinitionResponse = Record<
  string,
  Record<string, any>
>
